<template>
  <div>
    <div class="contentInfo">
      <Search
        v-if="[2, 3].includes(type) && dataList.length"
        :on-item-click="onItemClick"
        :values="[
          { title: '近7天', value: 7 },
          { title: '近30天', value: 30 },
          { title: '近180天', value: 180 }
        ]"
      />
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="contentInfo-item"
      >
        <div class="title">{{ item.title }}</div>
        <div v-for="(info, i) in item.list" :key="i" class="content">
          <p class="info">
            <span class="name">{{ info.key }}:</span>
            <span
              :class="['value', (info.url || info.extra) && 'active']"
              @click="
                {
                  info.url
                    ? goUrl(info.url)
                    : info.extra
                    ? showPopu(info.extra)
                    : ''
                }
              "
              >{{ info.value }}</span
            >
          </p>
        </div>
      </div>
      <empty
        v-if="dataList.length === 0"
        :desc="'没有获取到您的相关信息，请稍后再试'"
        :type="1"
        :img="'DefaultEmpty'"
        class="empty-box"
      ></empty>
    </div>
    <van-popup v-model="show" round position="bottom" closeable>
      <div class="popu-wrapper">
        <div class="popu-title">共{{ popuList.length }}条</div>
        <div v-if="!popuList.length" class="popu-content">
          暂未收集到您的位置信息
        </div>
        <div
          v-for="(item, index) in popuList"
          v-else
          :key="index"
          class="popu-content"
        >
          {{ item }}
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { API } from '@/api'
import { getStartAndEendTime } from '@/utils/utils'
import Search from '../components/search.vue'
import { navBar } from '@/utils/native_interactions/native_bar'
import Empty from '@/common/layout/empty/index'
export default {
  components: {
    Search,
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { type } = to.query
      switch (+type) {
        case 1:
          navBar.setTitle({
            text: '基本信息'
          })
          break
        case 2:
          navBar.setTitle({
            text: '使用过程信息'
          })
          break
        case 3:
          navBar.setTitle({
            text: '位置信息'
          })
          break
        case 4:
          navBar.setTitle({
            text: '设备信息'
          })
          break
        default:
          break
      }
      // 设置白色状态栏
      vm.$bridge.setLightStatusBar()
    })
  },
  data() {
    return {
      open: false,
      type: 1,
      show: false,
      popuList: [],
      dataList: []
    }
  },
  async created() {
    const [startTime, endTime] = getStartAndEendTime(7)
    const { type } = this.$route.query
    this.type = +type
    await this.getDataList({
      startTime,
      endTime
    })
  },
  methods: {
    openSearch() {
      this.open = !this.open
    },
    goUrl(url) {
      this.$autoRedirect(url)
    },
    showPopu(popuList) {
      this.popuList = popuList
      this.show = true
    },
    async onItemClick(item) {
      const [startTime, endTime] = getStartAndEendTime(item)
      await this.getDataList({
        startTime,
        endTime
      })
    },
    async getDataList(props = {}) {
      this.$Loading()
      try {
        const data = await API.personList.personalInfoList({
          ...props,
          type: this.type
        })
        this.dataList = data || []
      } catch (e) {
        this.$catch(e)
      }
      this.$Loading.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.contentInfo {
  height: 100vh;

  padding: 0.24rem;
  overflow: hidden;

  background-color: #f5f5f5;
  overflow-y: auto;
  > * {
    margin-bottom: 0.24rem;
  }
  &-item {
    padding: 0.24rem;

    background-color: #fff;

    border-radius: 0.24rem;
    .title {
      margin-bottom: 0.24rem;

      font-size: 0.36rem;
      font-weight: 600;
      color: #222;
    }
    .content {
      font-size: 0.28rem;
      line-height: 0.44rem;
      color: #888;
      .info {
        display: flex;
        .name {
          width: 1.4rem;
        }
        .value {
          flex: 1;
          word-break: break-all;
        }
        .active {
          color: #15bb5c;
        }
      }
    }
  }
}
.popu {
  &-wrapper {
    padding-bottom: 0.68rem;
  }
  &-title {
    height: 1.14rem;

    font-size: 0.36rem;
    line-height: 1.14rem;
    font-weight: 600;
    text-align: center;
    color: #333;
  }
  &-content {
    margin: 0.32rem 0;

    font-size: 0.28rem;
    text-align: center;
    color: #888;
  }
}
</style>
